import { saving, site } from '@yola/ws-sdk';
import getIsOpen from './is-open';
import getDisplayMode from './display-mode';

const { SAVED } = saving.constants.statuses;

// The `HostState` snapshot reported to the chat (see constants/messages.js).
// Returns a new object on every call — compare it with `shallowEqual`.
//
// Anything short of SAVED — UNSAVED, a save still in flight or a failed one —
// means the backend does not have the latest changes yet.
const getHostState = (rootState) => ({
  isOpen: getIsOpen(rootState),
  displayMode: getDisplayMode(rootState),
  currentPageId: site.selectors.getActivePageId(rootState) || null,
  hasUnsavedChanges: saving.selectors.getStatus(rootState) !== SAVED,
});

export default getHostState;
